import React from "react";

import { duration } from "@formant/core/model/duration";
import { HStack } from "@formant/ui/component/common/HStack";

import { ITeleopSession } from "../../../teleop/ITeleopSession";
import { useResizeWatcher } from "../../../utils/useResizeWatcher";
import { StandardButton } from "../../common/StandardButton";
import styles from "./index.scss";
import { useFontLoaded } from "./useFontLoaded";
import { defaultTerminalFont, useTeleopTerminal } from "./useTeleopTerminal";

interface ITerminalWindowProps {
    session: ITeleopSession;
    startMessage: string;
}

export function TerminalWindow(props: ITerminalWindowProps) {
    const { session, startMessage } = props;
    const fontLoaded = useFontLoaded(defaultTerminalFont);

    const term = useTeleopTerminal(session, startMessage);

    const { ref: resizer } = useResizeWatcher<HTMLDivElement>(term.onResize, {
        wait: (1 / 4) * duration.second,
    });

    if (!fontLoaded) {
        return null;
    }

    const canCopyPaste = !!navigator.clipboard;

    return (
        <>
            <div className={styles["terminal-container"]} ref={resizer}>
                <div
                    className={styles["terminal-view"]}
                    ref={term.containerRef}
                />
            </div>
            {canCopyPaste && (
                <HStack
                    hAlign="center"
                    innerSpacing="sm"
                    className={styles.operations}
                >
                    <StandardButton
                        disabled={!term.isReady}
                        onClick={term.onCopy}
                    >
                        Copy
                    </StandardButton>
                    <StandardButton
                        disabled={!term.isReady}
                        onClick={term.onPaste}
                    >
                        Paste
                    </StandardButton>
                </HStack>
            )}
        </>
    );
}
